import axios from 'axios'
import { config, url } from '../../../index'

const state = () => ({
  tableHeaders: [
    {
      title: 'Название',
      isSortable: false
    }
  ],
  statuses: [],
  isLoading: true,
  pagination: {
    pageList: {
      active: false,
      pages: []
    },
    currentTake: 10,
    currentPage: 1,
    lastPage: 0
  },
  updateModal: {
    active: false,
    status: {},
    validation: {}
  },
  createModal: {
    active: false,
    newStatusName: '',
    validation: {}
  }
})

const getters = {
  statuses: state => state.statuses,
  statusListIsLoading: state => state.isLoading,
  statusListTableHeaders: state => state.tableHeaders,
  statusListUpdateModal: state => state.updateModal,
  statusListCreateModal: state => state.createModal
}

const mutations = {
  // получение списка всех статусов
  GET_STATUSES: (state, statuses) => {
    // добавляем к каждому объекту свойство для отрисовки состояния меню (ред./удалить)
    state.statuses = statuses.map(status => {
      return {
        ...status,
        isControlsActive: false
      }
    })
    // убираем флаг "контент загружается"
    state.isLoading = false
  },
  // вкл/выкл меню (редактировать/удалить)
  STATUS_LIST_TOGGLE_CONTROLS: (state, itemId) => {
    state.statuses.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isControlsActive = !elem.isControlsActive
      } else if (itemId !== elem.id) {
        elem.isControlsActive = false
      }
    })
  },
  // выкл меню (редактировать/удалить) при клике вне элемента
  CLOSE_STATUS_LIST_CONTROLS: (state) => {
    state.statuses.forEach((elem) => {
      elem.isControlsActive = false
    })
  },
  // показ модалки для редактирования записи
  SHOW_STATUS_LIST_UPDATE_MODAL: (state, statusId) => {
    state.updateModal.active = true
    // помещаем в модалку копию объекта чтобы редактирование не затрагивало таблицу
    const copies = state.statuses.map(status => ({ ...status }))
    state.updateModal.status = copies.filter(status => {
      return status.id === statusId
    }).shift()
  },
  SET_UPDATED_STATUS_NAME: (state, name) => {
    state.updateModal.status.name = name
  },
  SHOW_STATUS_LIST_CREATE_MODAL: (state) => {
    state.createModal.active = true
  },
  SET_CREATED_STATUS_NAME: (state, name) => {
    state.createModal.newStatusName = name
  },
  // закрытие всех модалок
  CLOSE_STATUS_LIST_MODALS: (state) => {
    // модалка редактирвоания
    state.updateModal.active = false
    state.updateModal.status = {}
    // модалка создания
    state.createModal.active = false
    state.createModal.newStatusName = ''
  },
  SET_STATUS_LIST_MODAL_VALIDATION: (state, validationData) => {
    switch (validationData.modal) {
      case 'create':
        state.createModal.validation = validationData.validation
        break
      case 'update':
        state.updateModal.validation = validationData.validation
        break
      default:
        state.createModal.validation = {}
        state.updateModal.validation = {}
    }
  },
  // записть в стейт состояния пагинации
  SET_STATUS_LIST_PAGINATION: (state, paginationData) => {
    state.pagination.currentPage = paginationData.current_page
    state.pagination.lastPage = paginationData.last_page
    // заполняем массив номерами страниц от 1 до последней страницы
    state.pagination.pageList.pages = [...Array(paginationData.last_page).keys()].map(i => ++i)
  },
  TOGGLE_STATUS_LIST_PAGE_LIST: (state) => {
    state.pagination.pageList.active = !state.pagination.pageList.active
  },
  CLOSE_STATUS_LIST_PAGE_LIST: (state) => {
    state.pagination.pageList.active = false
  }
}

const actions = {
  getStatuses ({ state, commit }) {
    axios.get(`${url}/statuses?per-page=1`, config).then(response => {
      axios.get(`${url}/statuses?sort=-id&per-page=${response.headers['x-pagination-total-count']}`, config).then(response => {
        commit('GET_STATUSES', response.data.data)
      })
    }).catch(error => {
      console.log('ошибка получения списка статусов', error.response ? error.response : error)
    })
  },
  // раскомментить и отредактировать когда будет пагинация
  /* getPositionListPrevPage ({ state, commit }) {
    axios.get(`${url}/positions?orderBy=id&orderDir=DESC&take=${currentTake}&page=${currentPage - 1}`, config).then(response => {
      commit('GET_POSITIONS', response.data.data)
      commit('SET_POSITION_LIST_PAGINATION', response.data)
      commit('CLOSE_POSITION_LIST_PAGE_LIST')
    })
  },
  getPositionListNextPage ({ state, commit }) {
    const currentTake = state.pagination.currentTake
    const currentPage = state.pagination.currentPage
    axios.get(`${url}/positions?orderBy=id&orderDir=DESC&take=${currentTake}&page=${currentPage + 1}`, config).then(response => {
      commit('GET_POSITIONS', response.data.data)
      commit('SET_POSITION_LIST_PAGINATION', response.data)
      commit('CLOSE_POSITION_LIST_PAGE_LIST')
    })
  },
  getPositionListPage ({ state, commit }, pageNum) {
    const currentTake = state.pagination.currentTake
    axios.get(`${url}/positions?orderBy=id&orderDir=DESC&take=${currentTake}&page=${pageNum}`, config).then(response => {
      commit('GET_POSITIONS', response.data.data)
      commit('SET_POSITION_LIST_PAGINATION', response.data)
    })
  },
  togglePositionListPageList ({ commit }) {
    commit('TOGGLE_POSITION_LIST_PAGE_LIST')
  }, */
  // переключение всплывающих меню (ред./удалить)
  toggleStatusListItemControls ({ commit }, itemId) {
    commit('STATUS_LIST_TOGGLE_CONTROLS', itemId)
  },
  // показ модалки редактирования записи
  showStatusListUpdateModal ({ commit }, positionId) {
    commit('SHOW_STATUS_LIST_UPDATE_MODAL', positionId)
  },
  // редактирование имени записи
  setUpdatedStatusName ({ commit }, name) {
    commit('SET_UPDATED_STATUS_NAME', name)
  },
  // показ модалки создания записи
  showStatusListCreateModal ({ commit }) {
    commit('SHOW_STATUS_LIST_CREATE_MODAL')
  },
  // редактирование имени новой записи
  setCreatedStatusName ({ commit }, name) {
    commit('SET_CREATED_STATUS_NAME', name)
  },
  // закрытие всех модалок
  closeStatusListModals ({ commit }) {
    commit('CLOSE_STATUS_LIST_MODALS')
    // закрываем все всплывашки (ред./удалить)
    commit('CLOSE_STATUS_LIST_CONTROLS')
  },
  // создание записи
  createStatus ({ commit, state }) {
    if (state.createModal.newStatusName) {
      const postData = {
        name: state.createModal.newStatusName
      }

      axios.post(`${url}/statuses`, postData, config).then(response => {
        this.dispatch('getStatuses')
        this.dispatch('closeStatusListModals')
      }).catch(error => {
        console.log('Ошибка создания статуса:' + error)
      })
    } else {
      commit('SET_STATUS_LIST_MODAL_VALIDATION', { modal: 'create', validation: { type: 'error', message: 'Поле должно быть заполнено' } })
    }
  },
  // редактирование записи
  updateStatus ({ commit, state }) {
    if (state.updateModal.status.name) {
      const statusData = {
        id: state.updateModal.status.id,
        name: state.updateModal.status.name
      }

      axios.put(`${url}/statuses/${statusData.id}`, statusData, config).then(response => {
        this.dispatch('getStatuses')
        this.dispatch('closeStatusListModals')
      }).catch(error => {
        console.log('Ошибка редактирования статуса:' + error)
      })
    } else {
      commit('SET_STATUS_LIST_MODAL_VALIDATION', { modal: 'update', validation: { type: 'error', message: 'Поле должно быть заполнено' } })
    }
  },
  // очищаем поля валидации
  clearStatusListModalValidation ({ commit }) {
    commit('SET_STATUS_LIST_MODAL_VALIDATION', { modal: null, validation: null })
  },
  // удаление записи
  deleteStatus ({ commit }, statusId) {
    axios.delete(`${url}/statuses/${statusId}`, config).then(response => {
      console.log('Статус успешно удален')
      this.dispatch('getStatuses')
      this.dispatch('closeStatusListModals')
    }).catch(error => {
      console.log('Ошибка удаления статуса:' + error)
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
